import content from './content/what-is-forex-trading.json';

export const whatIsForexTradingMock = {
  name: 'what-is-forex-trading',
  layoutType: 1,
  areasList: [
    {
      id: 'what-is-forex-trading-main',
      componentName: 'Comp:WhatIsForexTradingPage',
      content: JSON.stringify(content)
    }
  ]
};
